module.exports = __webpack_public_path__ + "static/media/luncherLogo.79985e20.png";